import { DiscoveryIntroModal } from '@/components/announcements/DiscoveryIntroModal'
import { MonitorsIntroModal } from '@/components/announcements/MonitorsIntroModal'
import type { AnnouncementConfig } from '@/components/announcements/types'

/**
 * Changelog entries that get a forced modal (keyed by `entry_id`). This is an
 * allowlist on purpose: only entries listed here interrupt with a modal, so
 * the ~dozen existing changelog entries a user may have unread are never shown
 * retroactively. New entries opt in by adding a config here.
 */
export const ANNOUNCEMENT_REGISTRY: Record<string, AnnouncementConfig> = {
  '2026-07-07-monitors': {
    // Monitors is unavailable to CUI-compliant orgs, yet the changelog Knock
    // notification is broadcast to everyone — suppress it for CUI orgs.
    isEligible: ({ cuiEnabled }) => cuiEnabled === false,
    Body: MonitorsIntroModal,
  },
  '2026-07-15-market-intelligence': {
    // Web search, Deep Research, and company/people enrichment are all
    // external-web tools, unavailable to CUI-compliant orgs.
    isEligible: ({ cuiEnabled }) => cuiEnabled === false,
    Body: DiscoveryIntroModal,
  },
}
